var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bl_toolbar",class:_vm.styles},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("default"),(_vm.showArrow)?_c('span',{staticClass:"toggle_bl",on:{"click":function($event){_vm.$emit('click')}}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }